export const formatInvoiceDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-PE', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return dateString;
  }
};

// Único punto del proyecto que calcula "hace N meses" — todo lo demás que
// necesite antigüedad relativa reusa estos dos helpers en vez de
// reimplementar el cálculo (ver formatFechaVerificacion / formatFechaConTiempoRelativo).
const mesesDesde = (date: Date): number =>
  Math.floor((Date.now() - date.getTime()) / (1000 * 60 * 60 * 24 * 30.44));

const relativoMeses = (meses: number): string =>
  meses <= 0 ? 'hace menos de un mes' : meses === 1 ? 'hace 1 mes' : `hace ${meses} meses`;

// "15/03/2024 · hace 16 meses" — sin juicio sobre si es "vieja" o no, para
// fechas donde la antigüedad es solo informativa (ver formatFechaVerificacion
// para la variante que además marca si superó los 12 meses).
export const formatFechaConTiempoRelativo = (date: Date): string => {
  const fecha = date.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' });
  return `${fecha} · ${relativoMeses(mesesDesde(date))}`;
};

export interface FechaVerificacion {
  // "15/03/2024 · hace 16 meses"
  texto: string;
  // true cuando pasaron más de 12 meses — dispara el color ámbar en la UI.
  vencida: boolean;
}

// Formatea una fecha de verificación con su antigüedad relativa en meses,
// marcando si ya superó los 12 meses (ver KnownErrorFormModal.tsx / KnownErrorDetailModal.tsx).
export const formatFechaVerificacion = (date: Date): FechaVerificacion => {
  const meses = mesesDesde(date);
  return { texto: formatFechaConTiempoRelativo(date), vencida: meses > 12 };
};